import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtDate } from '../constants';

// "Recently Decided" — NOT a feed, NOT a timeline.
// Answers one question: what are the CURRENT key decisions of this project?
// Superseded decisions (status=done) stay in Evolution and behind a quiet toggle.
export default function RecentlyDecided({ decisions = [], t, locale }) {
  const navigate = useNavigate();
  const [showSuperseded, setShowSuperseded] = useState(false);

  const current = decisions.filter((d) => d.status !== 'done');
  const superseded = decisions.filter((d) => d.status === 'done');

  const descOf = (d) => {
    const evo = d.evolution || [];
    for (let i = evo.length - 1; i >= 0; i--) {
      const e = evo[i];
      if ((e.kind === 'note' || e.kind === 'decision') && e.text && e.text !== d.title) return e.text;
    }
    return '';
  };

  const Card = ({ d, isSuperseded }) => (
    <button
      type="button"
      className={`crs-decided__card${isSuperseded ? ' is-superseded' : ''}`}
      data-testid={`creator-decided-${d.id}`}
      onClick={() => navigate(`/creator/item/${d.id}`)}
    >
      <span className="crs-decided__top">
        <span className={`crs-decided__chip${isSuperseded ? ' is-superseded' : ''}`}>
          {isSuperseded ? (t.cr_superseded || 'Superseded') : (t.cr_current || 'Current')}
        </span>
        <span className="crs-decided__date">{fmtDate(d.updated_at, locale)}</span>
      </span>
      <span className="crs-decided__title">{d.title}</span>
      {descOf(d) && <span className="crs-decided__desc">{descOf(d)}</span>}
    </button>
  );

  return (
    <div data-testid="creator-recently-decided">
      {current.length === 0 && superseded.length === 0 ? (
        <p className="crs-empty">{t.cr_area_empty || 'Nothing here yet.'}</p>
      ) : (
        <div className="crs-decided__grid">
          {current.map((d) => <Card key={d.id} d={d} isSuperseded={false} />)}
          {showSuperseded && superseded.map((d) => <Card key={d.id} d={d} isSuperseded />)}
        </div>
      )}
      {superseded.length > 0 && (
        <button
          type="button"
          className="crs-decided__toggle"
          onClick={() => setShowSuperseded((s) => !s)}
          data-testid="creator-decided-toggle-superseded"
        >
          {showSuperseded ? '\u2212' : '+'} {superseded.length} {t.cr_superseded_plural || t.cr_superseded || 'superseded'}
        </button>
      )}
    </div>
  );
}
